import { Cart, Person, Product } from '../entities';

export enum CartEventType {
  // non-meaningful events not afecting the price
  personNameUpdated = 0,
  modalClosed = 1,
  personSelected = 10,
  discountsUpdated = 20,
  insuranceUpdated = 30,
  registerDataUpdated = 40,
  personSkillChanged = 50,
  cartInitialisedByIDB = 100,
  // meaningful events affecting the price
  cartInitialised = 110, // initialized cart has no discounts, fetch them
  dateRangeUpdated = 120, // updated base prices? Does it really?
  personAdded = 130, // might affect group discount, child free
  personRemoved = 140, // might affect group discount, child free
  personAgeUpdated = 150, // might affect discounts, discounts for new age not yet loaded
  productUpdated = 160, // might affect child free
  productRemoved = 170, // might affect child free
  promocodeUpdated = 180, // might affect given discounts
  couponcodeUpdated = 190 // might affect total due to balance, only known in cart response
}

export enum InsuranceType {
  flexi = 1,
  insurance = 2,
  insurancePlus = 3
}

export type AnyCartEvent =
  | CartEventProductRemoval
  | CartEventProductUpdated
  | CartEventPersonNameUpdated
  | CartEventPersonSelected
  | CartEventPersonSkillChanged
  | CartEventDiscountsUpdated
  | CartEventInsuranceUpdated
  | CartEventCartInitialisedByIDB
  | CartEventCartInitialised
  | CartEventDateRangeUpdated
  | CartEventRegisterDataUpdated
  | CartEventPersonAdded
  | CartEventPersonRemoved
  | CartEventPersonAgeUpdated
  | CartEventCouponcodeUpdated
  | CartEventPromocodeUpdated
  | CartEventProductUpdated;

export interface BaseCartEvent {
  eventType: number;
  cart: Cart;
}

export interface CartEventPersonNameUpdated extends BaseCartEvent {
  eventType: CartEventType.personNameUpdated;
}
export interface CartEventPersonSelected extends BaseCartEvent {
  eventType: CartEventType.personSelected;
}
export interface CartEventPersonSkillChanged extends BaseCartEvent {
  eventType: CartEventType.personSkillChanged;
}
export interface CartEventDiscountsUpdated extends BaseCartEvent {
  eventType: CartEventType.discountsUpdated;
}
export interface CartEventInsuranceUpdated extends BaseCartEvent {
  eventType: CartEventType.insuranceUpdated;
}
export interface CartEventCartInitialisedByIDB extends BaseCartEvent {
  eventType: CartEventType.cartInitialisedByIDB;
}
export interface CartEventCartInitialised extends BaseCartEvent {
  eventType: CartEventType.cartInitialised;
}
export interface CartEventDateRangeUpdated extends BaseCartEvent {
  eventType: CartEventType.dateRangeUpdated;
}
export interface CartEventRegisterDataUpdated extends BaseCartEvent {
  eventType: CartEventType.registerDataUpdated;
}
export interface CartEventPersonAdded extends BaseCartEvent {
  eventType: CartEventType.personAdded;
}
export interface CartEventPersonRemoved extends BaseCartEvent {
  eventType: CartEventType.personRemoved;
}
export interface CartEventPersonAgeUpdated extends BaseCartEvent {
  eventType: CartEventType.personAgeUpdated;
  person: Person;
}
export interface CartEventPromocodeUpdated extends BaseCartEvent {
  eventType: CartEventType.promocodeUpdated;
}
export interface CartEventCouponcodeUpdated extends BaseCartEvent {
  eventType: CartEventType.couponcodeUpdated;
}

export interface CartEventProductRemoval extends BaseCartEvent {
  eventType: CartEventType.productRemoved;
  cart: Cart;
  product: Product;
  person: Person;
}

export interface CartEventProductUpdated extends BaseCartEvent {
  eventType: CartEventType.productUpdated;
  cart: Cart;
  product: Product;
  person: Person;
  // if a product was "replaced", we have the previous version here. Used on analytics
  replacedProduct?: Product;
}

export class CartPersonInterface {
  products: { definitionId: number; addons?: number[] }[]; // {definitionId:12 (SNOWBOARD), addons: [1,2,3] (helmet,boots,insurance)}
  age: number;
  weight?: string;
  height?: string;
  shoe_size?: string;
  skill?: string;
}
export class CartInterface {
  persons: CartPersonInterface[];
  startDate?: string;
  endDate?: string;
  promotionCode?: string;
  couponCode?: string;
  insurances?: InsuranceType[];
}

export interface RegisterData {
  firstname: string;
  surname: string;
  customerCountry: string;
  phone: string;
  accommodation_name: string;
  accommodation_address: string;
  email: string;
}
